import React  from 'react';
function GoldZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Condition</th>
          <th > Résultats</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Obligation de Zakat	</td>
          <td>{result.goldZakatDuty === 'yes' ? 'Zakat obligatoire' : 'Zakat non obligatoire'}</td>
        </tr>
        <tr >
          <td>Poids d'or pur	 </td>
          <td>{result.totalPureGoldWeight} (g) </td>
        </tr>
        <tr >
          <td>Seuil de Zakat sur l'or</td>
          <td>{result.goldWeightThreshold} (g)</td>
        </tr>
        <tr >
          <td>Montant de Zakat à payer (en espèces)</td>
          <td>{result.moneyZakatAmount} </td>
        </tr>
        <tr >
          <td>Montant de Zakat à payer (en or)</td>
          <td>{result.goldZakatAmount} (g)</td>
        </tr>
      </tbody>
    </table>
  );
}
export default GoldZakatTable;
